<template>
  <b-overlay
    id="overlay-background"
    class="overlay-config analysis-list"
    :show="loading"
    rounded="sm"
  >
    <div :class="{'sctCol': !editable, 'setColEditable': editable }">
      <label :class="{'editable': !editable}" for="process-select">{{$t('processTitle')}}</label>
      <select
        v-if="editable"
        class="form-control input-pentagro"
        id="process-select"
        v-model="selectedProcess"
      >
        <option :value="null" disabled=true selected>{{$t('selectAProcess')}}</option>
        <template v-if="this.processes">
          <option
            v-for="process in this.processes"
            :key="`${process.id}-${process.description}`"
            :value="process"
          >
            {{ process.description }}
          </option>
        </template>
      </select>
      <label v-else>{{ returnElementById(processes, selectedProcess) }}</label>
    </div>
    <div :class="{'sctCol': !editable, 'setColEditable': editable }">
      <label :class="{'editable': !editable}" for="equipment-select">{{$t('equipmentTitle')}}</label>
      <select
        v-if="editable"
        class="form-control input-pentagro"
        id="equipment-select"
        v-model="selectedEquipment"
        :disabled="!selectedProcess"
      >
        <option :value="null" selected>{{$t('selectAEquipment')}}</option>
        <template v-if="this.equipments">
          <option
            v-for="equipment in filteredEquipments"
            :key="`${equipment.id}-${equipment.description}`"
            :value="equipment.id"
          >
            {{ equipment.description }}
          </option>
        </template>
      </select>
      <label v-else>{{ returnElementById(equipments, selectedEquipment) }}</label>
    </div>
    <div :class="{'sctCol': !editable, 'setColEditable': editable}">
      <label :class="{'editable': !editable}" for="product-select">{{$t('productTitle')}}</label>
      <select
        v-if="editable"
        class="form-control input-pentagro"
        id="product-select"
        v-model="selectedProduct"
      >
        <option :value="null" selected>{{$t('selectAProduct')}}</option>
        <template v-if="this.products">
          <option
            v-for="product in this.products"
            :key="`${product.id}-${product.description}`"
            :value="product.id"
          >
            {{ product.description }}
          </option>
        </template>
      </select>
      <label v-else>{{ returnElementById(products, selectedProduct) }}</label>
    </div>
  </b-overlay>
</template>

<script>
import { urlMainAPI } from "@/global";
import axios from "axios";

export default {
  name: "SelectOrigin",

  props: ["selected", "editable"],

  data() {
    return {
      selectedProcess: this.selected.processId,
      selectedEquipment: this.selected.equipmentId,
      selectedProduct: this.selected.productId,
      selectedProcessName: this.selected.processName,
      selectedEquipmentName: this.selected.equipmentName,
      selectedProductName: this.selected.productName,
      loading: false,
      processes: [],
      equipments: [],
      products: [],
      filteredEquipments: []
    };
  },

  watch: {
    selectedProcess(value) {
      this.$emit("selectedProcess", value.id);
      this.$emit("selectedProcessName", value.description);
      this.selectedEquipment = null;
      this.filterEquipmentsByProcess(value ? value.id : null);
    },
    selectedEquipment(value) {
      this.$emit("selectedEquipment", value);
      const equipment = this.equipments.find(x => x.id == value);
      if (equipment) {
        this.$emit("selectedEquipmentName", equipment.description);
      } else {
        this.$emit("selectedEquipmentName", "");
      }
    },
    selectedProduct(value) {
      this.$emit("selectedProduct", value);
      this.$emit("selectedProductName", this.products.find(x => x.id == value).description);
    },
  },

  methods: {
    async loadProcess() {
      const url = `${urlMainAPI}/getprocess`;
      await axios.get(url).then((res) => {
        if (res.data) {
          this.processes = res.data;
        }
      });
    },

    async loadEquipments() {
      const url = `${urlMainAPI}/getequipments`;
      await axios.get(url).then((res) => {
        if (res.data) {
          this.equipments = res.data;
          this.filterEquipmentsByProcess(this.selectedProcess ? this.selectedProcess.id : null);
        }
      });
    },

    filterEquipmentsByProcess(processId) {
      if (!processId) {
        this.filteredEquipments = [];
        return;
      }
      
      this.filteredEquipments = this.equipments.filter(equipment => 
        equipment.processId === processId
      );
    },

    async loadProducts() {
      const url = `${urlMainAPI}/getproducts`;
      await axios.get(url).then((res) => {
        if (res.data) {
          this.products = res.data;
        }
      });
    },

    returnElementById(array = [], i) {
      let el = array.find(x => x.id == i)
      if (el)
        return el.description
      else
        return 'Não Atribuído'
    },

    async loadOrigin() {
      this.loading = this.editable;
      await this.loadProcess();
      await this.loadEquipments();
      await this.loadProducts();
      this.loading = false;
    }
  },

  async created() {
    await this.loadOrigin();
  },
};
</script>

<style scoped src=".\occurrence.css"></style>
<style scoped>
.editable {
  font-weight: 700;
  margin-bottom: 0px;
}

.sctCol {
  display: grid;
  grid-template-rows: auto auto;
}

.setColEditable {
  width: 350px;
}
</style>